module.exports = __webpack_public_path__ + "static/media/JanKrigovsky.cf03fa01.jpg";